import { type FC } from 'react'

import { type LOCALE } from '../../i18n'

export type SeoHreflangLinkTagsContent = {
  href: string
  hrefLang: LOCALE
}

type SeoHreflangLinkTagsProps = {
  localisedVersions: SeoHreflangLinkTagsContent[]
}

export const SeoHeadHrefLangLinkTags: FC<SeoHreflangLinkTagsProps> = ({
  localisedVersions,
}) =>
  localisedVersions.map((version) => (
    <link
      href={version.href}
      hrefLang={version.hrefLang}
      key={version.href}
      rel="alternate"
    />
  ))
